import React from 'react';
import style from './General.module.scss'
import photo from "../../assets/photo.jpg"
import pic1 from "../../assets/1.jpg"
import pic2 from "../../assets/2.jpg"

const General = () => {
    return (
        <div className={style.general}>
            <section className={style.welcome__images}>
                <img src={pic1} className={style.imagesP}/>
                <div className={style.dzenstyle}>
                    <span className={style.style}>Стиль</span>
                    <span className={style.dzen}>Дзен</span>
                </div>
                <img src={pic2} className={style.imagesP}/>
            </section>
            <section className={style.painter__data}>
                <div className={style.painter__data__photoandname}>
                    <div className={style.painterImage__wrapper}>
                        <img className={style.image} src={photo}/>
                    </div>
                    <span className={style.hud}>Художник - Р.Х. Абдульмянов</span>
                </div>
                <div className={style.description}>

                    <p>Дзен – состояние ума, разумного восприятия, осознания значимости и ценности момента –
                        здесь и сейчас. Причем ценность эта существует независимо от наших мыслей и желаний.
                        Основная идея стиля дзен – отказаться от всего лишнего, чтобы увидеть важное и нужное.</p>
                    <p>Дзен - это ощущение мира таким, каков он есть, не разделённым искусственно на предметы и
                        действия, на плохое и хорошее. Как монета – это то, что заключено между аверсом и реверсом,
                        так и мир – то самое неуловимое «между».</p><br/>
                    <p>Картины формируются так же естественно, как скалы и трава, которые они изображают. Это не
                        означает, что художественная форма Дзэн создается чисто случайно, и картину может создать змея,
                        которую окунули в чернила, а потом оставили извиваться на листе бумаги. Скорее, для Дзэн не
                        существует дуализма и противоречия между природным элементом случайности и человеческим
                        элементом управления.</p><br/>
                    <p>Бесцельное существование является постоянной темой всех жанров искусства Дзэн и выражает
                        внутреннее состояние самого художника, который идет в Никуда и существует вне Времени.
                        Это ощущение иногда находит и на обычных людей, и именно в такие мгновения они постигают те
                        ослепительные проблески мироздания, которые освещают в памяти случайно подвернувшиеся образы:
                        запах горелых листьев на заре туманного осеннего утра, полет голубей в луче солнца на фоне тучи
                        или одинокий крик птицы в чаще леса. В искусстве Дзэн любой пейзаж, любой набросок бамбука,
                        колеблемого ветром, или одиноких скал – это эхо таких мгновений.</p>
                </div>
            </section>
        </div>
    );
};

export default General;